"use client";

import { Check, Copy } from "lucide-react";
import { useState } from "react";

export function InstallCommand({ command, label }: { command: string; label?: string }) {
  const [copied, setCopied] = useState(false);

  async function copy() {
    await navigator.clipboard.writeText(command);
    setCopied(true);
    window.setTimeout(() => setCopied(false), 1500);
  }

  return (
    <div>
      {label ? <p className="mb-2 text-xs font-medium text-slate-500">{label}</p> : null}
      <div className="group flex items-center gap-3 rounded-xl border border-slate-700 bg-slate-950 px-4 py-3 shadow-lg">
        <code tabIndex={0} className="focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-600 min-w-0 flex-1 overflow-x-auto whitespace-pre font-mono text-[12.5px] leading-relaxed text-slate-100 sm:text-sm">
          {command}
        </code>
        <button
          type="button"
          onClick={copy}
          aria-label="Copy command"
          className="shrink-0 rounded-lg border border-slate-700 bg-slate-800 p-2 text-slate-300 transition hover:bg-slate-700 hover:text-white"
        >
          {copied ? <Check className="h-4 w-4 text-emerald-400" /> : <Copy className="h-4 w-4" />}
        </button>
      </div>
    </div>
  );
}
